import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import InertiaSharedProps from "@/types/inertia";
import { toaster } from "@/components/ui/toaster";

const useInertiaToasts = () => {
  const { flash } = usePage<InertiaSharedProps>().props;

  useEffect(() => {
    if (flash.alert) {
      queueMicrotask(() => {
        toaster.error({ title: flash.alert });
      });
    }
    if (flash.notice) {
      queueMicrotask(() => {
        toaster.success({ title: flash.notice });
      });
    }
  }, [flash.alert, flash.notice]);
};

export default useInertiaToasts;
